import React from "react";
import { type FreefieldInputProps } from "../models";
import NumberInput, { type NumericValue } from "components/NumberInput";

const FreefieldDecimal = (props: FreefieldInputProps) => {
  const [value, setValue] = React.useState(props.initialValue ? parseFloat(props.initialValue) : undefined);

  const onChange = (newValue: NumericValue) => {
    setValue(newValue.value);
    props.onChange(newValue.value?.toString() ?? "");
  };

  return <NumberInput
    value={value}
    onChanged={onChange}
    canBeEmpty
    canBeNegative
    maxLength={12}
    decimalPoints={2}
    width={90}
  />;
};

export default FreefieldDecimal;